import { render } from "./New.vue?vue&type=template&id=6c78d22a&scoped=true"
import script from "./New.vue?vue&type=script&lang=js"
export * from "./New.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6c78d22a"

export default script